import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../../axiosinterceptor";

const API = "/code_enhance_plus_review_workflow_episode_list";
const ENHANCEPLUS_UNASSIGN  = "/code_enhance_plus_review_workflow_unassign";
const ENHANCEPLUS_RECALL = "/code_enhance_plus_review_workflow_recall";
export const REQUEST_STATUS = Object.freeze({
  IDLE: "IDLE",
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
});

const initialState = {
  payload: {
    header_id: [],              // or [] if your API supports multiple header_ids
    page_number: 1,
    page_size: 20,
    version: "",
    file_name: [],
    episode_id: [],
    medical_record_number:[],
    admission_date_from: "",
    admission_date_to: "",
    separation_date_from: "",
    separation_date_to: "",
    status: [],
    los: "",
    los_op: "",

    age: "",
    age_op: "",

    pallas_priority: [],
    speciality: [],
    actual_drg: [],
    predicted_drg1: [],
    predicted_drg2: [],
    principal_diagnosis: [],
    principal_procedure_code: [],

    audit_rule_flagged_status: false,
    audit_rule_reference_no: [],
    health_fund_identifier: [],

    sort_by: "",
    sort_order: "",
    is_global: false,
     is_flagged:false,
    recall:false,
    unassigned_page:false
  },

  response: {
    data: [],
    status: REQUEST_STATUS.IDLE,
    error: null,
  },
  unassign: {
    status: REQUEST_STATUS.IDLE,
    error: null,
  },

  recall: {
    status: REQUEST_STATUS.IDLE,
    error: null,
  },

  reflag: {
    status: REQUEST_STATUS.IDLE,
    error: null,
  },
};

export const getEnhancePlusWorkflowData = createAsyncThunk(
  "enhancePlusWorkflow/getEnhancePlusWorkflowData",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API, payload);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Something went wrong",
      );
    }
  },
);
export const getEnhancePlusWorkUnassignedEpisode = createAsyncThunk(
  "enhancePlusWorkflow/getEnhancePlusWorkUnassignedEpisode",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(ENHANCEPLUS_UNASSIGN, payload);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Something went wrong",
      );
    }
  },
);
export const recallEnhancePlusEpisodes = createAsyncThunk(
  "enhancePlusWorkflow/recallEnhancePlusEpisodes",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(ENHANCEPLUS_RECALL, payload);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message
      );
    }
  }
);

export const reflagEnhancePlusEpisodes = createAsyncThunk(
  "enhancePlusWorkflow/reflagEnhancePlusEpisodes",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(ENHANCEPLUS_RECALL, payload);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message
      );
    }
  }
);

export const exportEnhancePlusWorkflowCSV = createAsyncThunk(
  "enhancePlusWorkflow/exportEnhancePlusWorkflowCSV",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {

      const response = await axiosInstance.post(
        "/code_enhance_plus_review_workflow_export",
        payload

      );
      return fulfillWithValue(response.data); 
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Something went wrong",
      );
    }
  },
);
const enhancePlusWorkflowSlice = createSlice({
  name: "enhancePlusWorkflow",
  initialState,
  reducers: {
    updatedEnhancePlusPayload(state, action) {
      state.payload = {
        ...state.payload,
        ...action.payload,
      };
    },
    resetEnhancePlusPayload(state) {
      state.payload = initialState.payload;
    },
    resetEnhancePlusResponse(state) {
      state.response = {
        data: [],
        status: REQUEST_STATUS.IDLE,
        error: null,
      };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getEnhancePlusWorkflowData.pending, (state) => {
        state.response.status = REQUEST_STATUS.LOADING;
        state.response.error = null;
      })
      .addCase(getEnhancePlusWorkflowData.fulfilled, (state, action) => {
        state.response.status = REQUEST_STATUS.SUCCESS;
        state.response.data = action.payload;
      })
      .addCase(getEnhancePlusWorkflowData.rejected, (state, action) => {
        state.response.status = REQUEST_STATUS.FAILURE;
        state.response.error = action.payload;
      })
      // Unassign
    .addCase(getEnhancePlusWorkUnassignedEpisode.pending, (state) => {
      state.response.status = REQUEST_STATUS.LOADING;
      state.response.error = null;
    })
    .addCase(getEnhancePlusWorkUnassignedEpisode.fulfilled, (state) => {
      state.response.status = REQUEST_STATUS.SUCCESS;
    })
    .addCase(getEnhancePlusWorkUnassignedEpisode.rejected, (state, action) => {
      state.response.status = REQUEST_STATUS.FAILURE;
      state.response.error = action.payload;
    })

    // Recall
    .addCase(recallEnhancePlusEpisodes.pending, (state) => {
      state.response.status = REQUEST_STATUS.LOADING;
      state.response.error = null;
    })
    .addCase(recallEnhancePlusEpisodes.fulfilled, (state) => {
      state.response.status = REQUEST_STATUS.SUCCESS;
    })
    .addCase(recallEnhancePlusEpisodes.rejected, (state, action) => {
      state.response.status = REQUEST_STATUS.FAILURE;
      state.response.error = action.payload;
    })

    // Reflag
    .addCase(reflagEnhancePlusEpisodes.pending, (state) => {
      state.response.status = REQUEST_STATUS.LOADING;
      state.response.error = null;
    })
    .addCase(reflagEnhancePlusEpisodes.fulfilled, (state) => {
      state.response.status = REQUEST_STATUS.SUCCESS;
    })
    .addCase(reflagEnhancePlusEpisodes.rejected, (state, action) => {
      state.response.status = REQUEST_STATUS.FAILURE;
      state.response.error = action.payload;
    });

  },
});

export const { updatedEnhancePlusPayload, resetEnhancePlusPayload, resetEnhancePlusResponse } = enhancePlusWorkflowSlice.actions;
export const initialPayload = initialState.payload;
export default enhancePlusWorkflowSlice.reducer;